import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import { Link } from 'react-router-dom';
import { Layout, Card, Breadcrumb, Row, Tabs, Icon } from 'antd';
import { UsersTab } from './UsersTab';
import MetersTab from './MetersTab';
import InviteUserModal from './InviteUserModal';

// Selectors
import { isFromAdministrationView } from '../../../data/app/selector';
import { isRoleAdministrator, isRoleInstaller } from '../../../data/auth/selectors';
import { isOwnerOfCurrentlyLoadedHouse } from '../../../data/homes/selectors';

// Actions
import {
    fetchHomeDetail,
    handleDeleteUser,
    onInviteNewResidentModalIsShown
} from '../../../data/homes/actions';

// Others
import { strings } from '../../../localization';
import { ROUTE_NAMES } from '../../../utils';
import SiteConfigTab from './SiteConfigTab';

const { TabPane } = Tabs;

class HomeDetail extends Component {
    componentWillMount() {
        const { fetchHomeDetail, match } = this.props;
        fetchHomeDetail(match.params);
    }

    render() {
        const {
            detailData,
            detailIsLoading,
            fetchHomeDetail,
            isFromAdministrationView,
            isOwnerOfHouse,
            isAdmin,
            inviteModalIsShown,
            onInviteNewResidentModalIsShown,
            handleDeleteUser,
            match,
            isInstaller
        } = this.props;
        const environment = JSON.parse(process.env.APP_CONFIG).REACT_APP_HEROKU_ENV;
        return (
            <React.Fragment>
                <Layout key="admin-users-content">
                    <Layout.Content style={{ padding: '10px' }}>
                        <Card style={{ marginBottom: '30px' }}>
                            <h2 data-testid="headline">
                                <Link
                                    to={
                                        isFromAdministrationView
                                            ? ROUTE_NAMES.ADMINISTRATION
                                            : ROUTE_NAMES.HOMES
                                    }
                                >
                                    <Icon type="arrow-left" theme="outlined" />
                                </Link>
                                &nbsp; &nbsp;
                                {strings.homes.detail.detailRouteTitle}
                                {detailIsLoading || !detailData
                                    ? ` - ${strings.loading}`
                                    : ` - ${
                                          detailData && detailData.size > 0 ? detailData.get('name') : ''
                                      }`}
                                {!detailIsLoading && detailData && detailData.size > 0
                                    ? ` (${
                                          detailData.get('kwhCost') ? detailData.get('kwhCost') : '-'
                                      } ${strings.homes.kwhEuro})`
                                    : ''}
                            </h2>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>{strings.appName}</Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    {isFromAdministrationView ? (
                                        <Link to={ROUTE_NAMES.ADMINISTRATION}>
                                            <Icon type="setting" />
                                            &nbsp;
                                            {strings.administration.route}
                                        </Link>
                                    ) : (
                                        <Link to={ROUTE_NAMES.HOMES}>
                                            <Icon type="deployment-unit" />
                                            &nbsp;
                                            {strings.homes.route}
                                        </Link>
                                    )}
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>{strings.homes.detail.detailRoute}</Breadcrumb.Item>
                            </Breadcrumb>
                        </Card>
                        <Row>
                            <Tabs
                                defaultActiveKey="0"
                                size="large"
                                tabBarGutter={30}
                                tabBarStyle={{ marginBottom: 0 }}
                            >
                              <TabPane
                                    key="0"
                                    tab={
                                        <span>
                                            <Icon type="cluster" />
                                            {strings.homes.detail.metersLabel}
                                        </span>
                                    }
                                >
                                    <MetersTab
                                        msgs={strings}
                                        isAdmin={isAdmin}
                                        isOwnerOfHouse={isOwnerOfHouse}
                                        params={match.params}
                                        isInstaller={isInstaller}
                                    />
                                </TabPane>
                                <TabPane
                                    key="1"
                                    tab={
                                        <span>
                                            <Icon type="team" />
                                            {strings.homes.detail.usersLabel}
                                        </span>
                                    }
                                >
                                    <UsersTab
                                        msgs={strings}
                                        isLoading={detailIsLoading}
                                        params={match.params}
                                        onInviteNewResidentModalIsShown={onInviteNewResidentModalIsShown}
                                        fetchHomeDetail={fetchHomeDetail}
                                        handleDeleteUser={handleDeleteUser}
                                        isOwnerOfHouse={isOwnerOfHouse}
                                        isAdmin={isAdmin}
                                        isInstaller={isInstaller}
                                        ownerData={
                                            detailData && detailData.size > 0
                                                ? detailData.get('ownerUser')
                                                : undefined
                                        }
                                        userList={
                                            detailData && detailData.size > 0
                                                ? detailData.get('residents')
                                                : undefined
                                        }
                                    />
                                </TabPane>                                
                                <TabPane
                                    key="2"
                                    tab={
                                    <span>
                                        <Icon type="cluster" />
                                            {strings.homes.detail.siteConfig}
                                    </span>
                                }
                                    >
                                    <SiteConfigTab
                                        msgs={strings}
                                        isAdmin={isAdmin}
                                        isOwnerOfHouse={isOwnerOfHouse}
                                        isInstaller={isInstaller}
                                        params={match.params}
                                    />
                                </TabPane>                                
                            </Tabs>
                        </Row>
                    </Layout.Content>
                </Layout>

                {inviteModalIsShown && <InviteUserModal params={match.params} msgs={strings} />}
            </React.Fragment>
        );
    }
}
export default connect(
    (state, ownProps) => ({
        ...ownProps,
        detailIsLoading: state.homes.getIn(['detail', 'isLoading']),
        detailData: state.homes.getIn(['detail', 'data']),
        inviteModalIsShown: state.homes.getIn(['detail', 'users', 'inviteModal', 'isShown']),
        isFromAdministrationView: isFromAdministrationView(state),
        isOwnerOfHouse: isOwnerOfCurrentlyLoadedHouse(state),
        isAdmin: isRoleAdministrator(state),
        isInstaller: isRoleInstaller(state)
}),
    {
        fetchHomeDetail,
        onInviteNewResidentModalIsShown,
        handleDeleteUser
    }
)(HomeDetail);
